module.exports = __webpack_public_path__ + "img/BOXEA-LOGO.b8f411af.png";